"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScriptUrl = void 0;
function getScriptUrl() {
    return tryGetDefaultScriptUrl() || null;
}
exports.getScriptUrl = getScriptUrl;
function tryGetDefaultScriptUrl() {
    var _a;
    try {
        return (_a = document.currentScript) === null || _a === void 0 ? void 0 : _a.getAttribute('src');
    }
    catch (_b) {
        return;
    }
}
//# sourceMappingURL=getScriptUrl.js.map